<template>
  <div class="py-3">
    <page-loading v-if="!item" />
    <page-title v-if="item" :title="pageTitle" />
    <hr />
    <div v-if="item" class="mt-3">
      <subscription-fields :item="item" v-on:submit="onConfirmSubmit" v-on:cancel="onCancel">
        <template v-slot:save>Save</template>
      </subscription-fields>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "SubscriptionEdit",
  props: ['id'],
  data() {
    return {
      item: null
    };
  },
  computed: {
    pageTitle: function () {
      return 'Subscription: ' + this.item.displayName;
    }
  },
  methods: {
    load: function () {
      let url = '/api/subscription/' + this.id;

      axios
        .get(url)
        .then(response => {
          console.log(response);

          // TODO: Check for 200?

          this.item = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    onCancel(evt) {
      this.$router.push('/subscription');
    },
    onConfirmSubmit(evt) {
      this.$bvModal.msgBoxConfirm('Are you sure you want to save this record? Because a lot of this data is tied to Stripe, saving it incorrectly may cause data loss.', {
        title: 'You\'re Doing Something Dangerous',
        okVariant: 'danger',
        okTitle: 'Yes',
        cancelTitle: 'No'
      })
      .then(value => {
        if (value)
          this.onSubmit();
      })
    },
    onSubmit(evt) {
      let url = '/api/subscription/' + this.id;

      axios
        .put(url, this.item)
        .then(response => {
          this.item = response.data;

          this.$parent.showToast('Your changes to "' + this.item.displayName + '" were saved successfully.', {
            title: 'Saved',
            variant: 'success',
            autoHideDelay: 5000
          });

          this.$router.push('/subscription');
        })
        .catch(error => {
          console.log(error);

          let errorMessage = 'Unable to save "' + this.item.displayName + '". An unknown error occurred.';

          if (error.response.status == 400)
            errorMessage = 'Unable to save "' + this.item.displayName + '". The data you provided could not be validated.';
          else if (error.response.status == 403)
            errorMessage = 'Unable to save "' + this.item.displayName + '". You are not logged in or do not have access.';
          else if (error.response.status == 409)
            errorMessage = 'Unable to save "' + this.item.displayName + '". The item has been edited since you loaded the page. Reload this page to get the latest changes.';

          this.$parent.showToast(errorMessage, {
            title: 'Error Saving',
            variant: 'danger',
            autoHideDelay: 5000
          });
        });
    }    
  },
  mounted () {
    this.load();
    // Use this instead of the previous line to test the "Loading" bar
    //window.setTimeout(this.load, 3000);
  }
};
</script>